/* tslint:disable */
import {
  Machine,
  UserAccount,
  ChallengeTimeline,
  UserMachineEntryScore
} from '../index';

declare var Object: any;
export interface UserMachineEntryInterface {
  "machineId": number;
  "userAccountId": number;
  "challengeTimelineId": number;
  "createdAt": Date;
  "createdBy"?: number;
  "updatedAt": Date;
  "updatedBy"?: number;
  "id"?: number;
  machine?: Machine;
  userAccount?: UserAccount;
  challengeTimeline?: ChallengeTimeline;
  userMachineEntryScores?: UserMachineEntryScore[];
}

export class UserMachineEntry implements UserMachineEntryInterface {
  "machineId": number;
  "userAccountId": number;
  "challengeTimelineId": number;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  machine: Machine;
  userAccount: UserAccount;
  challengeTimeline: ChallengeTimeline;
  userMachineEntryScores: UserMachineEntryScore[];
  constructor(data?: UserMachineEntryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UserMachineEntry`.
   */
  public static getModelName() {
    return "UserMachineEntry";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UserMachineEntry for dynamic purposes.
  **/
  public static factory(data: UserMachineEntryInterface): UserMachineEntry{
    return new UserMachineEntry(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UserMachineEntry',
      plural: 'UserMachineEntries',
      path: 'UserMachineEntries',
      idName: 'id',
      properties: {
        "machineId": {
          name: 'machineId',
          type: 'number'
        },
        "userAccountId": {
          name: 'userAccountId',
          type: 'number'
        },
        "challengeTimelineId": {
          name: 'challengeTimelineId',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        machine: {
          name: 'machine',
          type: 'Machine',
          model: 'Machine',
          relationType: 'belongsTo',
                  keyFrom: 'machineId',
          keyTo: 'id'
        },
        userAccount: {
          name: 'userAccount',
          type: 'UserAccount',
          model: 'UserAccount',
          relationType: 'belongsTo',
                  keyFrom: 'userAccountId',
          keyTo: 'id'
        },
        challengeTimeline: {
          name: 'challengeTimeline',
          type: 'ChallengeTimeline',
          model: 'ChallengeTimeline',
          relationType: 'belongsTo',
                  keyFrom: 'challengeTimelineId',
          keyTo: 'id'
        },
        userMachineEntryScores: {
          name: 'userMachineEntryScores',
          type: 'UserMachineEntryScore[]',
          model: 'UserMachineEntryScore',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userMachineEntryId'
        },
      }
    }
  }
}
